import React from 'react'
import { FormattedMessage } from 'react-intl'

import styles from './offline-banner.styl'

const OfflineBanner = () => {
  return (
    <p className={styles.banner}>
      <FormattedMessage
        id="label.you_are_offline"
        defaultMessage="You are offline. Changes made now may not be saved."
      />
    </p>
  )
}

OfflineBanner.displayName = 'OfflineBanner'

export default OfflineBanner
